type EvaluationFinalResponse = {
  formatted?: Record<string, unknown>;
  supplied?: Record<string, unknown> & { meta?: Record<string, unknown> };
};

export const getRerunFormData = (response?: EvaluationFinalResponse | null) => {
  if (!response) return {};
  const data = response.formatted
    ? { ...response.supplied, ...response.formatted }
    : {};
  return data;
};

export const evaluationHasMetaFormData = (response?: EvaluationFinalResponse | null) => (
  Boolean(response?.supplied && typeof response.supplied.meta === 'object' && response.supplied.meta !== null)
);
